
import { initializeApp } from '@firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
const firebaseConfig = {
    apiKey: "AIzaSyDQhAs-smDaa8pQueTFm5YRvBgKka2i5Nc",
    authDomain: "lastcall-b65af.firebaseapp.com",
    projectId: "lastcall-b65af",
    storageBucket: "lastcall-b65af.firebasestorage.app",
    messagingSenderId: "60941222662",
    appId: "1:923842254029:web:a8a6101f78d7971cb14584"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const functions = getFunctions(app);
const auth = getAuth(app);

// Only connect to emulators if explicitly in development
if (process.env.REACT_APP_ENV === 'development') {
    console.log('Development mode detected');
    // Remove emulator connections if not using them
}

export { app, db, functions, auth };

export default app;